import { render, staticRenderFns } from "./CreateAlerts.vue?vue&type=template&id=180895ca&"
import script from "./CreateAlerts.vue?vue&type=script&lang=js&"
export * from "./CreateAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports